import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// 
const firebaseConfig = {
  apiKey: "AIzaSyA4_o2yXHgJo3ZUQIpM_1OhCYT4vH_3t1E",
  authDomain: "sahal-guur.firebaseapp.com",
  projectId: "sahal-guur",
  storageBucket: "sahal-guur.firebasestorage.app",
  messagingSenderId: "660843588402",
  appId: "1:660843588402:web:1d8f401508d8daa469c52b"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

/** Create auth users without signing out the current admin session. */
export const getSecondaryAuth = () => {
  const secondaryName = 'SecondaryAuth';
  const existing = getApps().find((a) => a.name === secondaryName);
  const secondaryApp = existing || initializeApp(firebaseConfig, secondaryName);
  return getAuth(secondaryApp);
};

export default app;